<template>
  <div class="modal fade" tabindex="-1" data-backdrop="static" role="dialog" id="receiveModal">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header light">
          <h5 class="modal-title">Receive Inbound Shipment</h5>
        </div>
        <div class="modal-body p-0">
          <table class="table">
            <thead>
              <th>SKU</th>
              <th>Description</th>
              <th>Expected</th>
              <th>Received</th>
            </thead>
            <tbody>
              <tr v-for="item in order.items" :key="item.id">
                <td>{{ item.product.sku }}</td>
                <td>{{ item.product.name }}</td>
                <td><a href="#" @click="item.qty_receiving=item.qty">{{ item.qty }}</a></td>
                <td>
                  <input
                    type="number" 
                    v-model="item.qty_receiving"
                    class="form-control pull-left text-center"
                    style="width: 75px;">
                </td>
              </tr>
              <tr v-if="order.items.length == 0">
                <td colspan="4" class="text-center">No items for this order</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
          <button type="button" class="btn btn-primary" @click="submit">Receive</button>
        </div>
      </div>
    </div>
  </div>

</template>

<script>

export default {
  name: 'receive-modal',

  props: {
    order: Object,
  },

  methods: {

    submit() {
      let complete = true
      this.order.items.forEach(item => {
        if(item.qty != item.qty_receiving) {
          complete = false
        }
      })

      if (!complete) {
        const con = confirm("Are you sure this order was missing items?")
        if (con) {
          this.$emit('receive-order')  
        }
      } else {
        this.$emit('receive-order')
      }
    },

  }
}
</script>